import React from "react";
import "./ToggleButton.scss";
function ToggleButton({
  onLabel = "",
  offLabel = "",
  handleChange,
  isChecked,
  ...rest
}) {
  console.log(rest);
  return (
    <label className="toggle">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        {...rest}
      />
      <span className="slider"></span>
      <span className="labels" data-on={onLabel} data-off={offLabel}></span>
    </label>
  );
}

export default ToggleButton;
